import React, {useEffect, useState, Fragment} from 'react'
import { matchTemplateFieldWithValue, initialValue } from '../../lib/utils';
import {VisDiv, ViewLabelValueField,  RegisterTemplateData, FieldDropdown, NewDeviceField} from '../../components';
import { addValueForDropdown, sortByLabel, expandReference, translatedLabel } from '../../lib/utils'; 
import {useStateContext} from '../../context/StateContext';
import { trackDoc } from '../RegisterTemplateData';

export const ViewEditPresidio = ({label, registerTemplate, device, template, trackedChanges, setTrackedChanges, setTemplateDevice, templateDevice, deviceEdit, isError, errorMessage, isDuplicate, substitute }) => {
    const testing = false;
    
    const initialValueDoc = () => {
        //console.log("nlkwjcnlkeswjc", device, templateDevice)
        if (!device && !templateDevice) {
            return undefined;
        }
        
        if (device && substitute) {
            const substituteDevice = expandReference(device.substituteDevice, template.devices);
            if (!device?.substituteDevice) {
                return {...device, label: templateDevice?.label, value: templateDevice?.label};
            }
            return {...device, label: substituteDevice?.label, value: substituteDevice?.label};
        }
        
        if (device) {
            return {...device, label: templateDevice?.label, value: templateDevice?.label};
        }
      
        
        // Handle case when device is undefined but templateDevice exists
/*         if (templateDevice?._ref) {
            return {...templateDevice, label: templateDevice?.label, value: templateDevice?.label};
        } */
        
        return undefined;
    };

    const [presidioInitialValue, setPresidioInitialValue] = useState(undefined);
    const [subPresidioInitialValue, setSubPresidioInitialValue] = useState(undefined);

    useEffect(() => {
        const newValue = initialValueDoc();
        //console.log("skjdddsjknjkdsndskjfn")
        setPresidioInitialValue(newValue);
        setSubPresidioInitialValue(newValue);
        //console.log("USE EFFECT VIEW EDIT PRESIDIO", newValue, device, templateDevice);
    }, [device, templateDevice]); // put back in templateDevice as now it works

    const options = () => {
        if (template?.devicesManualOrder) {
            return addValueForDropdown(template?.devices);
        }
        return addValueForDropdown(template?.devices)?.sort(sortByLabel);
    };

    if (deviceEdit) {
        return (
            <NewDeviceField label={label}> 
               {/*  <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv> */}
                <FieldDropdown
                    isMulti={false}
                    isSearchable="isSearchable"
                    initialValue={substitute ? subPresidioInitialValue : presidioInitialValue}
                    isError={isError}
                    errorMessage={errorMessage}
                    placeHolder={undefined}
                    options={options()}
                    onChange={(value) => {
                        setPresidioInitialValue(value);
                        setTemplateDevice(value);
                        const referenceTemplateField = {
                            _type: 'reference',
                            _ref: value?._id
                        };
                        const trackData = {
                            registerTemplate, 
                            device, 
                            referenceTemplateField, 
                            updatedValue: value, 
                            trackedChanges, 
                            isPresidio: true
                        };
                        trackDoc(trackData, setTrackedChanges);
                    }}
                /> 
            </NewDeviceField> 
        );
    }

    return (
        <>  
            <ViewLabelValueField
                label={initialValueDoc()?.label}
                value={initialValueDoc()?.label}
                highlight={undefined}
            />
        </>
    );
}

export const ViewEditFields = ({newDoc, fieldMessages=[], trackedChanges, setTrackedChanges=()=>{}, deviceEdit, array, device, state=[], setState, collection, currentTemplateDevice, errors, isDuplicate, deviceNonConformities=[], registerTemplate}) => 
    array && array.map?.((item, index) => {
        const {LDB} = useStateContext();
        const testing = false;

        const key = item?._id;
        const error = !Array.isArray(errors) ? [] : errors?.filter?.((y)=>y?.check)?.find?.((x)=>x?.templateId == item?._id);
        const value = matchTemplateFieldWithValue(item?._id, collection, registerTemplate, true)?.value;

        const testFunction = () => {
            console.log("jhdehdbye", {item, registerTemplate, value: matchTemplateFieldWithValue(item?._id, collection, registerTemplate, true)?.value});
        };
            
        const allNonConformities = !Array.isArray(deviceNonConformities) ? [] : deviceNonConformities?.filter?.((x)=>x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO");

        const isFieldGenerated = !! item.fieldGeneratedNonConformity;
        const isFieldGeneratedNonConfPresent = () => {
            const fieldNonConformities = !Array.isArray(item?.nonConformities) ? [] : item?.nonConformities?.map?.((obj)=>{
                return !Array.isArray(allNonConformities) ? false : allNonConformities?.some?.((y)=>y?.nonConformity?._ref == obj?._id);
            });
            if(isDuplicate){return false;}
            if(fieldNonConformities?.some?.(x=>x)){return true;}

            const minMaxArray = [item?.maxNonConformity, item?.minNonConformity, item?.zeroNonConformity];
            const minMaxNonConformities = !Array.isArray(minMaxArray) ? [] : minMaxArray?.map?.((obj)=>{
                return !Array.isArray(allNonConformities) ? false : allNonConformities?.some?.((y)=>y?.nonConformity?._ref == obj?._ref);
            });

            if(minMaxNonConformities?.some?.(x=>x)){return true;}

            return false;
        };

        return (
           <Fragment key={key}>
            { deviceEdit ?
                <VisDiv>
                    <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                    <VisDiv rules={[!isFieldGeneratedNonConfPresent()]}>
                        <RegisterTemplateData 
                            item={item} 
                            device={device}
                            currentTemplateDevice={currentTemplateDevice} 
                            deviceFields={state} 
                            setDeviceFields={setState}  
                            trackedChanges = {trackedChanges}
                            setTrackedChanges = {setTrackedChanges}
                            isError={error?.check}
                            errorMessage={error?.errorMessage}
                            registerTemplate={registerTemplate} 
                            fieldMessages={fieldMessages}    
                        /> 
                    </VisDiv>
                </VisDiv> :
                <VisDiv rules={[value]}>
                    <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                    <ViewLabelValueField 
                        label={translatedLabel(item, LDB)?.toUpperCase()} 
                        value={value?.toUpperCase()}
                        valueType={item?.fieldType}
                        notification={item?.generatesNotification}
                    />
                </VisDiv>}
            </Fragment>  
        );
    });

export const ViewEditField = ({deviceEdit, item, device, state, setState, trackedChanges, setTrackedChanges=()=>{}, collection, currentTemplateDevice, errors, registerTemplate}) => {
    const testing = false;
    const testFunction = () => {
        //console.log("item:", item)
        //console.log("nonConfFound:", isFieldGeneratedNonConfPresent())
        //console.log(allNonConformities)
        //console.log("error", error)
    };
    const key = item?._id;
    const error = errors && errors.filter?.((y)=>y.check)?.find?.((x)=>x.templateId == item._id);
    const value = matchTemplateFieldWithValue(item?._id, collection)?.value;

    const userNonConformities = device?.deviceNonConformities ? device?.deviceNonConformities : [];
    const fieldNonConformities = device?.fieldDeviceNonConformities ? device?.fieldDeviceNonConformities : [];
    const allNonConformities = [...userNonConformities, ...fieldNonConformities].filter?.((x)=>x?.status!=="COMPLETATO" && x?.status!=="ARCHIVIATO");

    const isFieldGenerated = !! item?.fieldGeneratedNonConformity;
    const isFieldGeneratedNonConfPresent = () => {
        const fieldNonConformities = item?.nonConformities?.map?.((obj)=>{
            return allNonConformities.some?.((y)=>y?.nonConformity?._ref == obj?._id);
        });

        if(fieldNonConformities?.some?.(x=>x)){return true;}

        const minMaxArray = [item?.maxNonConformity, item?.minNonConformity, item?.zeroNonConformity];
        const minMaxNonConformities = minMaxArray?.map?.((obj)=>{
            return allNonConformities.some?.((y)=>y?.nonConformity?._ref == obj?._ref);
        });

        if(minMaxNonConformities?.some?.(x=>x)){return true;}

        return false;
    };

    return (
       <Fragment key={key}>
        { deviceEdit ?
            <VisDiv>
                <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                <VisDiv rules={[!isFieldGeneratedNonConfPresent()]}>
                    <RegisterTemplateData 
                        item={item} 
                        currentTemplateDevice={currentTemplateDevice} 
                        deviceFields={state} 
                        setDeviceFields={setState} 
                        trackedChanges = {trackedChanges}
                        setTrackedChanges = {setTrackedChanges}
                        isError={error?.check}
                        errorMessage={error?.errorMessage} 
                        registerTemplate={registerTemplate}  
                        device={device}     
                    /> 
                </VisDiv>
            </VisDiv> :
            <VisDiv rules={[value]}>
                <VisDiv rules={[testing]}><button onClick={testFunction}>test field</button></VisDiv>
                <ViewLabelValueField 
                    label={item?.label}
                    value={value}
                    valueType={item?.fieldType}
                    notification={item?.generatesNotification}
                />
            </VisDiv>}
        </Fragment>  
    );
};
